import { render, staticRenderFns } from "./CatalogsPage.vue?vue&type=template&id=3151fc8a&scoped=true"
import script from "./CatalogsPage.vue?vue&type=script&lang=js"
export * from "./CatalogsPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogsPage.vue?vue&type=style&index=0&id=3151fc8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151fc8a",
  null
  
)

export default component.exports